module.exports = __webpack_public_path__ + "img/360-degrees.cb03836d.svg";